module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/free-issue-tasks-table.a3656e54.png";